import fallbackCover from '../../../assets/stockPhotos/r1_c1.jpg'

export const NewArticleProps = {
  initialValue: 'initial Content',
  author: 'Anonymous',
  title: 'OIJPCR Article',
  slug: 'This is an Article',
  volume: 1,
  cover: fallbackCover,
}